import React, { useRef } from "react";
import styled from "styled-components";

// @ts-expect-error - JS ファイルの型定義なし
import { useHlsPlayer } from "../../../hooks/useHlsPlayer";
import { MGK_TEASER_HLS } from "../mgkContent";

const Frame = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: #000;
  border-radius: 12px;
  overflow: hidden;
`;

const Video = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

/**
 * MGK ティーザー動画（HLS）。旧ページと同じく無音の自動ループ再生。
 * 動画は src/assets/videos/hls/mgk_teaser（720p ソースなので 360p / 720p の 2 レンディション）。
 */
const MgkTeaser: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  useHlsPlayer(MGK_TEASER_HLS, videoRef, true);

  return (
    <Frame>
      <Video
        ref={videoRef}
        controls
        controlsList="nodownload"
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
      />
    </Frame>
  );
};

export default MgkTeaser;
